import SmartLockApiCallerInstance from '../utils/SmartLockApiCallerInstance';
import { SMART_LOCK_API_ENDPOINTS } from '../URLConstants';

export const GetAllRoles = async (page) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.ROLE_URL}?page=${page}&limit=10`
  );
  return response;
};

export const AddRoleData = async (data) => {
  const response = await SmartLockApiCallerInstance.post(SMART_LOCK_API_ENDPOINTS.ROLE_URL, data);
  return response;
};
export const GetRoleDetailsById = async (id) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.ROLE_URL}/${id}`
  );
  return response;
};
export const UpdateRoleDetailsById = async (data, id) => {
  const response = await SmartLockApiCallerInstance.patch(
    `${SMART_LOCK_API_ENDPOINTS.ROLE_URL}/${id}`,
    data
  );
  return response;
};
export const DeleteRoleById = async (id) => {
  const response = await SmartLockApiCallerInstance.delete(
    `${SMART_LOCK_API_ENDPOINTS.ROLE_URL}/${id}`
  );
  return response;
};

export const GetRoleList = async (id) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.ALL_ROLE_DATA}/${id}`
  );
  return response;
};
